/* vorn cookie banner — consentimento por regiao.
   - Paises com exigencia legal (EU/EEA + UK + CH, lista em data-cb-countries):
     MOSTRA o banner (opt-in). Accept grava o consentimento REAL do Shopify.
   - Paises FORA dessa lista (nao exigem opt-in): concede o consentimento
     AUTOMATICAMENTE (silencioso, sem banner) -> libera o Pixel/eventos pra
     montar publicos. Sem isso, o visitante non-EU ficava com consent "" e os
     eventos nao eram usaveis pra Custom Audiences (publicos travados em ~20).
   - Pais DESCONHECIDO (geo falhou): NAO concede (pode ser UE) -> so remove.
   Geolocaliza por IP real (GeoJS), com fallback pro pais resolvido pelo
   Shopify no servidor (localization.country). */
(function () {
  var KEY = 'vorn_cookie_consent_v1';
  var GEO_KEY = 'vorn_cookiebar_geo_v1';
  var GEO_TTL = 24 * 60 * 60 * 1000;

  function readGeoCache() {
    try {
      var raw = localStorage.getItem(GEO_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.iso || !data.ts) return null;
      if (Date.now() - data.ts > GEO_TTL) return null;
      return data.iso;
    } catch (e) { return null; }
  }

  function writeGeoCache(iso) {
    try { localStorage.setItem(GEO_KEY, JSON.stringify({ iso: iso, ts: Date.now() })); } catch (e) {}
  }

  var _cpLoadTriggered = false;
  function ensureConsentApi() {
    /* garante Shopify.customerPrivacy mesmo em tema que nao a expoe sozinho
       (blindagem: o dono troca de tema sem avisar). No-op se a API ja existe. */
    if (_cpLoadTriggered) return;
    _cpLoadTriggered = true;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {}
  }

  function grantRealConsent(attempt) {
    /* Concede o consentimento REAL do Shopify (Shopify.customerPrivacy),
       liberando de fato o Pixel/Customer Events pro visitante — nao so o
       aviso visual. A API carrega async (aqui via loadFeatures): tenta de
       novo por ate ~5s. Nao repete se ja estiver concedido. */
    attempt = attempt || 0;
    ensureConsentApi();
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') {
        try {
          var cur = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
          if (cur && cur.marketing === 'yes') return; /* ja concedido -> nada a fazer */
        } catch (e) {}
        cp.setTrackingConsent(
          { marketing: true, analytics: true, preferences: true, sale_of_data: true },
          function () {}
        );
        return;
      }
    } catch (e) {}
    if (attempt < 25) setTimeout(function () { grantRealConsent(attempt + 1); }, 200);
  }

  function resolveCountry(serverIso, cb) {
    var cached = readGeoCache();
    if (cached) { cb(cached); return; }

    var settled = false;
    var timer = setTimeout(function () {
      if (settled) return;
      settled = true;
      cb(serverIso || null);
    }, 2500);

    fetch('https://get.geojs.io/v1/ip/country.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        var iso = data && data.country ? String(data.country).toUpperCase() : (serverIso || null);
        if (iso) writeGeoCache(iso);
        cb(iso);
      })
      .catch(function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        cb(serverIso || null);
      });
  }

  function init() {
    var bar = document.querySelector('[data-cookiebar]');
    if (!bar) return;

    var ok = null;
    try { ok = localStorage.getItem(KEY); } catch (e) { /* storage bloqueado -> segue pro check de geo */ }
    if (ok) { bar.remove(); return; }

    var allowed = (bar.getAttribute('data-cb-countries') || '')
      .split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
    var serverIso = (bar.getAttribute('data-server-country') || '').toUpperCase();

    resolveCountry(serverIso, function (iso) {
      if (iso && allowed.indexOf(iso) !== -1) {
        /* regiao que exige opt-in (UE/EEA/UK/CH) -> mostra o banner */
        void bar.offsetWidth; /* reflow: garante que a transicao anima (sem depender de rAF) */
        bar.classList.add('is-open');
        return;
      }
      /* pais CONHECIDO e fora da lista -> nao precisa de banner, mas concede o
         consentimento automaticamente pra o Pixel montar publicos.
         pais DESCONHECIDO (iso vazio) -> NAO concede (pode ser UE). */
      if (iso) grantRealConsent();
      bar.remove();
    });

    var btn = bar.querySelector('[data-cookiebar-accept]');
    if (btn) {
      btn.addEventListener('click', function () {
        try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
        grantRealConsent();
        bar.classList.remove('is-open');
        setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 350);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
